export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14355.97e1d0e0.jpg";